const SET_FUNDER_REPORT_DATE_RANGE = (state, { field, value }) => {
  state.currentAdministrator.fundersReport[field] = value;
  state.fundersReportErrors = [];
};

export default SET_FUNDER_REPORT_DATE_RANGE;
